module.exports = __webpack_public_path__ + "media/images/features/wedding-ceremony-cost/main-008a199a564afd8b6d6149757cc35bdb.jpg";